import { render, staticRenderFns } from "./ProductDetailViewOld.vue?vue&type=template&id=0a03846a&scoped=true"
import script from "./ProductDetailViewOld.vue?vue&type=script&lang=js"
export * from "./ProductDetailViewOld.vue?vue&type=script&lang=js"
import style0 from "./ProductDetailViewOld.vue?vue&type=style&index=0&id=0a03846a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a03846a",
  null
  
)

export default component.exports